import {ChangeDetectorRef, Component, effect, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {AuthenticationService} from '../authentication/authentication.service';
import {LocalStorageKeys} from "../models/server/Constants";
import {OrganisationService} from "../services/organisation.service";
import { HomePricingComponent } from '../home-pricing/home-pricing.component';
import { HomeStartComponent } from '../home-start/home-start.component';
import {LocalStoreService} from "../services/local-store.service";

@Component({
    selector: 'home-component',
    templateUrl: 'home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [HomeStartComponent, HomePricingComponent]
})
export class HomeComponent {

  // injected services
  private localStore = inject(LocalStoreService);
  public authService = inject(AuthenticationService);
  private orgService = inject(OrganisationService);
  private cdr = inject(ChangeDetectorRef);

  isAuthenticated = false;
  orgIsActivated: boolean = false;

  constructor() {
    effect((onCleanup) => {
      const isAuthenticated = this.authService.isAuthenticated();
      this.isAuthenticated = isAuthenticated;

      let orgSub: Subscription;
      if (!isAuthenticated) {
        this.orgIsActivated = false;
        this.cdr.markForCheck();
        return;
      }

      orgSub = this.orgService.getOrganisation().subscribe(org => {
        this.orgIsActivated = org?.isActivated;
        this.cdr.markForCheck();
      });

      onCleanup(() => orgSub?.unsubscribe());
    });

    this.localStore.removeItem(LocalStorageKeys.LastPage);
  }
}
